import { Link } from 'react-router-dom';
import { LEGAL_LINKS, COPYRIGHT } from './legal';

/**
 * Desktop-only footer (PRD §6.2.1): copyright + legal links. Links come from
 * the shared `legal` module and route to in-app pages (rendered in the main
 * content area) so the desktop footer and the mobile drawer stay in lockstep.
 */
export default function Footer() {
  return (
    <footer className="appfooter">
      <span>{COPYRIGHT}</span>
      {LEGAL_LINKS.map(({ label, to }) => (
        <Link key={label} to={to}>{label}</Link>
      ))}
    </footer>
  );
}
